<div class="image-select" [hidden]="uploadFile?.completed" (click)="fileInputEl?.click()">
  <div class="file-select text-center">
    <!-- <i class="icon-upload-notebook"></i> -->

    <span [slide]="!uploadFile" [hidden]="uploadprdSignUpInProgress"><img src="assets/images/icons/upload.svg" />
      <br />
      Upload File</span>

    <span *ngIf="!(uploadLoaction === 'prdSignUp' || uploadLoaction === 'ipo')" [slide]="uploadFile">Uploading ({{
      uploadFile?.progress }}%)</span>
    <div *ngIf="(uploadLoaction === 'prdSignUp' || uploadLoaction === 'ipo') && uploadprdSignUpInProgress"
      class="loader"></div>
  </div>
  <input (change)="filesSelected($event)" type="file" #fileInputEl />
</div>
<div class="image-holder" *ngIf="uploadFile?.completed" [ngClass]="circledImg ? 'circle' : ''">
  <span *ngIf="uploadLoaction !== 'ipo'">
    <img #uploadedImg
      *ngIf="!(uploadFile?.extension === 'pdf' || uploadFile?.extension === 'pptx' || uploadFile?.extension === 'docx')"
      src="{{ uploadFile?.url }}" [style.width.%]="!circledImg ? imgRatio : null" (load)="onLoad()" /></span>
  <span *ngIf="uploadLoaction === 'ipo'">
    <img #uploadedImg
      *ngIf="!(uploadFile?.extension === 'pdf' || uploadFile?.extension === 'pptx' || uploadFile?.extension === 'docx')"
      [src]="getImagePath(uploadFile?.ipoURL)" />

    <!-- 
    <img
      #uploadedImg
      *ngIf="!(uploadFile?.extension === 'pdf' || uploadFile?.extension === 'pptx' || uploadFile?.extension === 'docx')"
      src="{{ uploadFile?.baseUrl }}"
      [style.width.%]="imgRatio"
    /> -->
  </span>
  <div *ngIf="uploadFile?.extension === 'pdf'" style="width: 100%; height: 100%">
    <span *ngIf="uploadLoaction === 'ipo'">
      <img *ngIf="!base64Image || is_safari" class="ipo-pdf" src="assets/images/file-icons/file-pdf-1.svg" alt="pdf" />
      <img *ngIf="!is_safari && base64Image" [src]="getImagePath(uploadFile?.ipoURL)"
        onerror="this.src='assets/images/file-icons/file-pdf-1.svg'" />
    </span>
    <span *ngIf="uploadLoaction !== 'ipo'">
      <img *ngIf="is_safari" class="ipo-pdf" src="assets/images/file-icons/file-pdf-1.svg" alt="pdf" />
      <embed *ngIf="!is_safari" [attr.src]="uploadFile.baseUrl" type="application/pdf" width="100%" height="100%" />
    </span>
  </div>
  <!-- <div *ngIf="!is_safari"> -->
  <!-- <iframe [hidden]="uploadFile?.extension !== 'pdf'" [src]="uploadFile?.secureURL" width="100%" height="100%" frameborder="0"></iframe> -->
  <!-- <iframe [hidden]="uploadFile?.extension !== 'pdf'" [src]="getUrl(uploadFile?.url)" width="100%" height="100%" frameborder="0"></iframe> -->
  <!-- </div> -->

  <!-- <embed
    *ngIf="uploadFile?.extension === 'pdf'"
    [attr.src]="domSanitizer.bypassSecurityTrustResourceUrl('https://docs.google.com/gview?url=' + uploadFile.url + '&embedded=true')"
    type="application/pdf"
    width="100%"
    height="100%"
  /> -->
  <img *ngIf="uploadFile?.extension === 'pptx'" src="assets/images/file-icons/file-powerpoint-2.svg" alt="pptx" />
  <img *ngIf="uploadFile?.extension === 'docx'" src="assets/images/file-icons/file-words-2.svg" alt="docx" />
</div>
<div class="image-remove" *ngIf="!disableRemove" [hidden]="!uploadFile || !uploadFile?.completed"
  (click)="removeFile()">Remove</div>
<div class="image-change" *ngIf="disableRemove" [hidden]="!uploadFile || !uploadFile?.completed"
  (click)="changeFile(); fileInputEl?.click()">
  Change
</div>